var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ZEC Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenEx-(video)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "translate(-908.000000, -282.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(908.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9911308,1.0658141e-14 C8.96674058,1.0658141e-14 1.0658141e-14,8.96674058 1.0658141e-14,19.9911308 C1.0658141e-14,31.0155211 8.96674058,39.9822616 19.9911308,39.9822616 C31.0155211,39.9822616 39.9822616,31.0155211 39.9822616,19.9911308 C39.9822616,8.96674058 31.0155211,1.0658141e-14 19.9911308,1.0658141e-14 Z M19.9911308,36.6829268 C10.7849224,36.6829268 3.29933481,29.1973392 3.29933481,19.9911308 C3.29933481,10.7849224 10.7849224,3.29933481 19.9911308,3.29933481 C29.1973392,3.29933481 36.6829268,10.7849224 36.6829268,19.9911308 C36.6829268,29.1973392 29.1973392,36.6829268 19.9911308,36.6829268 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9911308,35.7427938 C11.2917276,35.7427938 4.23946785,28.6905341 4.23946785,19.9911308 C4.23946785,11.2917276 11.2917276,4.23946785 19.9911308,4.23946785 C28.6905341,4.23946785 35.7427938,11.2917276 35.7427938,19.9911308 C35.7427938,28.6905341 28.6905341,35.7427938 19.9911308,35.7427938 Z M12.8603104,26.2084257 L12.8603104,29.2594235 L18.3148559,29.2594235 L18.3148559,32.6031042 L21.6674058,32.6031042 L21.6674058,29.2594235 L27.1219512,29.2594235 L27.1219512,25.2239468 L18.6607539,25.2239468 L27.1219512,13.7472284 L27.1219512,10.6962306 L21.6674058,10.6962306 L21.6674058,7.36141907 L18.3148559,7.36141907 L18.3148559,10.6962306 L12.8603104,10.6962306 L12.8603104,14.7405765 L21.3215078,14.7405765 L12.8603104,26.2084257 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZec);
export default __webpack_public_path__ + "static/media/zec.0c478dc1.svg";
export { ForwardRef as ReactComponent };